import { IValidationPasswordFormValues } from 'affiny-core/modules/api/repositories/validationPassword/validationPassword.types';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import { IRegistrationFormValues } from '../../repositories/registration/registration.types';
import {
  IApiRegistrationAccount,
  IApiValidationAccount,
  TApiRegistrationLandingHistory,
} from './registration.types';

export const validationEncoder = (
  registrationForm: Partial<
    IRegistrationFormValues & IValidationPasswordFormValues
  >
): IApiValidationAccount => {
  const {
    password,
    email,
    nickname,
    birthDay,
    birthMonth,
    birthYear,
    genderSearch,
    genderSelf,
    placeId,
  } = registrationForm;

  const authentication = password
    ? {
        authentication: {
          password: {
            clear_password: password,
          },
        },
      }
    : {};

  const birthdateFormatted = tryToFormatBirthdate(
    birthDay,
    birthMonth,
    birthYear
  );

  const account = {
    account: {
      ...(email ? { email } : {}),
      ...(nickname ? { nickname } : {}),
      ...(birthdateFormatted ? { birthdate: birthdateFormatted } : {}),
      ...(placeId ? { place_id: parseInt(placeId, 10) } : {}),
      ...(genderSearch ? { search_gender: genderSearch } : {}),
      ...(genderSelf ? { gender: genderSelf } : {}),
    },
  };

  return {
    type: 'account',
    attributes: {
      ...authentication,
      ...account,
      context: {},
    },
  };
};

const tryToFormatBirthdate = (
  birthDay?: string,
  birthMonth?: string,
  birthYear?: string
): string | undefined =>
  birthDay &&
  birthMonth &&
  birthYear &&
  formatBirthdate(birthDay, birthMonth, birthYear);

const formatBirthdate = (
  birthDay: string,
  birthMonth: string,
  birthYear: string
): string =>
  format(
    parse(`${birthMonth}-${birthDay}-${birthYear}`, 'MM-dd-yyyy', new Date()),
    'yyyy-MM-dd'
  );

export interface IRegisterEncoderParams {
  registrationForm: IRegistrationFormValues &
    Partial<IValidationPasswordFormValues>;
  blackbox: string;
  captchaResponse: string | undefined;
  partnersOffers: boolean | undefined;
  marketingCode: string | undefined;
}

export function registrationEncoder({
  registrationForm,
  blackbox,
  captchaResponse,
  partnersOffers,
  marketingCode,
}: IRegisterEncoderParams): IApiRegistrationAccount {
  const {
    password,
    email,
    nickname,
    birthDay,
    birthMonth,
    birthYear,
    genderSearch,
    genderSelf,
    communicationChoice,
    placeId,
  } = registrationForm;

  const authentication = {
    authentication: {
      password: {
        clear_password: password ? password : '',
      },
    },
  };

  const account = {
    account: {
      email,
      nickname,
      birthdate: formatBirthdate(birthDay, birthMonth, birthYear),
      place_id: parseInt(placeId, 10),
      search_gender: genderSearch,
      gender: genderSelf,
      endpoint_marketing_code: marketingCode,
    },
  };

  const landingHistory: TApiRegistrationLandingHistory = marketingCode
    ? [
        {
          time: format(new Date(), "yyyy-MM-dd'T'HH:mm:ssXX"),
          code_origin: marketingCode,
        },
      ]
    : undefined;

  return {
    type: 'registration',
    attributes: {
      ...authentication,
      ...account,
      context: {
        blackbox,
        landing_history: landingHistory,
        optins: {
          mail_partner_offer: partnersOffers || false,
          mail_soulmate_selection: communicationChoice,
        },
      },
      meta: captchaResponse ? { captchaResponse } : {},
    },
  };
}
